import RcDomainMap from "../../../common/RcDomainMap.js";
import GpsDevice from './GpsDevice.js';

export default class GpsDeviceMap extends RcDomainMap {
  static MODEL_NAME = GpsDevice.MODEL_NAME + "Map";

  constructor(domain, data) {
    super(domain, data, GpsDeviceMap.MODEL_NAME);
  }

  copy() {
    var data = this._copy();
    return new GpsDeviceMap(this.domain, data);
  }

  find() {
    var keys = this.keys();
    var found = new GpsDeviceMap(this.domain, {});
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var data = this.domain.gpsDevices().findById(key);
      var item = new GpsDevice(this.domain, data);
      if (!item.isNew()) {
        found.add(item);
      }
    }
    return found;
  }

  sortByVehicleName() {
    let list = this.list();
    return list.sort((a, b) => {
      let av = a.vehicle().find();
      let bv = b.vehicle().find();
      if (av.name() > bv.name()) {
        return 1;
      }
      if (av.name() < bv.name()) {
        return -1;
      }
      return 0;
    });
  }

  list() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getGpsDevice(key);
      values.push(item);
    }
    return values;
  }

  first() {
    var all = this.list();
    if (all.length > 0) {
      return all[0];
    }
    return new GpsDevice(this.domain);
  }

  getGpsDevice(key) {
    var value = super.get(key);
    return new GpsDevice(this.domain, value);
  }

  addGpsDevice(item) {
    this.add(item).done();
    return this;
  }

  imeis() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getGpsDevice(key);
      values.push(item.imei());
    }
    return values;
  }
}
